import { render } from "./DynamicHtmlH4.vue?vue&type=template&id=0a76454e&ts=true"
import script from "./DynamicHtmlH4.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH4.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH4.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a76454e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a76454e', __exports__)) {
    api.reload('0a76454e', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH4.vue?vue&type=template&id=0a76454e&ts=true", () => {
    api.rerender('0a76454e', render)
  })

}


export default __exports__